import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import brand from "@/config/brand";
import { Reveal } from "@/components/Reveal";

const PortfolioPreview = () => (
  <section id="work" data-testid="featured-portfolio-section" className="bg-cream py-20 md:py-28 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div className="max-w-xl">
          <p className="text-xs font-sans uppercase tracking-[0.28em] font-semibold text-turquoise-deep mb-5 flex items-center gap-3">
            <span className="w-10 h-px bg-turquoise inline-block" />
            Our Work
          </p>
          <h2 className="font-serif font-medium tracking-tight text-charcoal text-2xl sm:text-3xl lg:text-4xl leading-tight">
            Real Websites. <span className="italic text-turquoise">Real Businesses.</span>
          </h2>
        </div>
        <p className="font-sans text-sm text-taupe max-w-sm leading-relaxed md:text-right">
          From beautiful business websites to interactive tools, explore websites and digital
          experiences we've created.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8">
        {brand.portfolio.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.1} className="h-full">
            <article
              data-testid={`portfolio-card-${p.id}`}
              className="group h-full flex flex-col bg-cream-dark border border-taupe/15 rounded-2xl overflow-hidden shadow-[0_10px_30px_rgba(0,0,0,0.03)] hover:border-turquoise/50 hover:-translate-y-1.5 hover:shadow-[0_24px_48px_-16px_rgba(0,175,163,0.2)] transition-[border-color,transform,box-shadow] duration-300"
            >
              <a
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block relative overflow-hidden aspect-[4/3]"
                aria-label={`Visit ${p.title} website`}
              >
                <img
                  src={p.image}
                  alt={`${p.title} website screenshot`}
                  loading="lazy"
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </a>
              <div className="p-7 flex flex-col flex-1">
                <p className="text-[11px] font-sans uppercase tracking-[0.18em] text-turquoise-deep font-semibold">
                  {p.category}
                </p>
                <h3 className="mt-2 font-serif font-medium text-xl text-charcoal leading-snug">
                  {p.title}
                </h3>
                <p className="mt-3 font-sans text-sm text-taupe leading-relaxed">{p.description}</p>
                <a
                  data-testid={`portfolio-view-button-${p.id}`}
                  href={p.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group/link mt-6 inline-flex items-center gap-2 w-fit border-2 border-charcoal text-charcoal hover:bg-charcoal hover:text-cream px-5 py-2.5 rounded-full font-sans text-sm font-medium transition-colors duration-300"
                >
                  View Website
                  <ArrowUpRight size={15} className="transition-transform duration-300 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" />
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-14 text-center">
        <Link
          data-testid="portfolio-view-all-button"
          to="/portfolio"
          className="group inline-flex items-center gap-2 border-2 border-charcoal text-charcoal hover:bg-charcoal hover:text-cream px-9 py-4 rounded-full font-sans font-medium text-base transition-colors duration-300"
        >
          View Our Portfolio
          <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
  </section>
);

export default PortfolioPreview;
